import { FunnelSimple } from '@phosphor-icons/react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';

/**
 * Date-range filter bar — filters Tracker by Interview Date or Joining Date.
 *
 * Props are intentionally controlled by the parent so it remains a thin presentational component.
 */
export const DateFilterBar = ({
  dateFilterField, setDateFilterField,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  onClear,
  filteredCount,
  totalCount,
}) => (
  <div
    className="mb-4 flex flex-wrap items-end gap-3 bg-[#0F3622] border-2 border-[#143E29] rounded-md p-3"
    data-testid="date-filter-bar"
  >
    <div className="flex items-center gap-2 text-white">
      <FunnelSimple size={20} weight="duotone" className="text-[#A3E635]" />
      <span className="text-xs font-bold uppercase tracking-wider">Filter by</span>
    </div>
    <select
      data-testid="date-filter-field"
      value={dateFilterField}
      onChange={(e) => setDateFilterField(e.target.value)}
      className="bg-white border-2 border-[#A3E635] rounded-md px-3 py-2 text-black font-bold text-sm cursor-pointer"
    >
      <option value="interview_date">Interview Date</option>
      <option value="date_of_joining">Joining Date</option>
    </select>
    <div className="flex items-end gap-2">
      <div>
        <Label htmlFor="date-from" className="text-[10px] font-bold uppercase tracking-wider text-white">From</Label>
        <Input
          id="date-from"
          data-testid="date-from"
          type="date"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
          className="bg-white border-2 border-[#A3E635] rounded-md px-3 py-1.5 text-black font-bold text-sm"
        />
      </div>
      <div>
        <Label htmlFor="date-to" className="text-[10px] font-bold uppercase tracking-wider text-white">To</Label>
        <Input
          id="date-to"
          data-testid="date-to"
          type="date"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
          className="bg-white border-2 border-[#A3E635] rounded-md px-3 py-1.5 text-black font-bold text-sm"
        />
      </div>
      {(dateFrom || dateTo) && (
        <Button
          data-testid="clear-date-filter"
          onClick={onClear}
          className="bg-[#F87171] text-white border-2 border-black rounded-md font-bold px-3 py-1.5 text-xs shadow-[2px_2px_0px_0px_rgba(10,10,10,1)] hover:-translate-y-0.5 transition-all"
        >
          Clear
        </Button>
      )}
    </div>
    <div className="ml-auto text-sm font-bold text-white">
      {filteredCount} <span className="text-[#A3E635]">of</span> {totalCount}
    </div>
  </div>
);
